import React from 'react';

import { useTranslation } from 'next-i18next';
// import PropTypes from 'prop-types';
import Link from 'next/link';
import classNames from 'classnames';
import styles from './Breadcrumb.module.scss';

const Breadcrumb = ({ items = [] }) => {
    const { t } = useTranslation();

    if (!items || items.length <= 1) {
        return null;
    }

    return (
        <nav className={`${styles['Root']} grid`} aria-label="Breadcrumbs">
            <div className={styles['Container']}>
                <ul className={styles['Crumb']}>
                    {items.map((item, index) => {
                        if (!item.url) {
                            return null;
                        }
                        return (
                            <li
                                key={index}
                                className={classNames(styles['ListItem'], {
                                    [styles['First']]: index === 0,
                                    [styles['Last']]: index === items.length - 1,
                                })}>
                                <Link className={styles['Link']} href={item.url}>
                                    {item.title}
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </nav>
    );
};

Breadcrumb.propTypes = {};

export default Breadcrumb;
